var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"header invoices_grid lg:tw-px-8 tw-px-4 tw-pb-2 tw-pt-4 tw-text-ci-gray-400 tw-uppercase tw-font-semibold tw-text-xs tw-sticky"},[_c('div',[_vm._v("RECHNUNG / DATUM")]),_c('div',[_vm._v("PATIENT")]),_c('div'),_c('div',[_vm._v("ZUGEWIESENE ZAHLUNGEN")]),_c('div',{staticClass:"align_right"},[_vm._v("BETRAG / OFFEN")])])
}]

export { render, staticRenderFns }